import prismicJS from '@prismicio/client';
import PrismicDOM, { RichText as RichText$1 } from 'prismic-dom';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Embed = {
  name: 'PrismicEmbed',
  functional: true,
  props: {
    field: {
      type: Object,
      required: true
    },
    wrapper: {
      type: [String, Object, Function],
      required: false,
      "default": 'div'
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;
    var field = props.field,
        wrapper = props.wrapper;

    if (!field || !field.html) {
      return null;
    }

    var embedUrl = field.embed_url,
        type = field.type,
        providerName = field.provider_name;

    var attrs = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, data.attrs), embedUrl && {
      'data-oembed': embedUrl
    }), type && {
      'data-oembed-type': type
    }), providerName && {
      'data-oembed-provider': providerName
    });

    return h(wrapper, _objectSpread2(_objectSpread2({}, Object.assign(data, {
      attrs: attrs
    })), {}, {
      domProps: {
        innerHTML: field.html
      }
    }));
  }
};

var Image = {
  name: 'PrismicImage',
  functional: true,
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;
    var field = props.field;

    if (!field) {
      return null;
    }

    var url = field.url,
        alt = field.alt,
        copyright = field.copyright;
    return h('img', Object.assign(data, {
      attrs: _objectSpread2(_objectSpread2({}, data.attrs), {}, {
        src: url,
        alt: alt || "",
        copyright: copyright
      })
    }));
  }
};

var isInternalURL = function isInternalURL(url) {
  /**
   * @see Regex101 expression: {@link https://regex101.com/r/1y7iod/1}
   */
  var isInternal = /^\/(?!\/)/.test(url);
  /**
   * @see Regex101 expression: {@link https://regex101.com/r/RnUseS/1}
   */

  var isSpecialLink = !isInternal && !/^https?:\/\//i.test(url);
  return isInternal && !isSpecialLink;
};

var Link = (function (_ref) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? "a" : _ref$component;
  return {
    name: "PrismicLink",
    functional: true,
    props: {
      field: {
        type: Object,
        required: true
      },
      linkResolver: {
        type: Function,
        required: false
      },
      target: {
        type: String,
        "default": undefined,
        required: false
      },
      rel: {
        type: String,
        "default": undefined,
        required: false
      },
      blankTargetRelAttribute: {
        type: String,
        "default": "noopener noreferrer",
        required: false
      }
    },
    render: function render(h, _ref2) {
      var props = _ref2.props,
          data = _ref2.data,
          children = _ref2.children,
          parent = _ref2.parent;
      var field = props.field,
          linkResolver = props.linkResolver;

      if (!field) {
        return null;
      }

      var url = parent.$prismic ? parent.$prismic.asLink(field, linkResolver) : PrismicDOM.Link.url(field, linkResolver || function () {
        return null;
      });

      if (isInternalURL(url) && !props.target) {
        data.props = data.props || {};
        data.props.to = url;
        return h(component, data, children);
      }

      data.attrs = _objectSpread2(_objectSpread2({}, data.attrs), {}, {
        href: url
      });

      if (typeof props.target !== "undefined") {
        data.attrs.target = props.target;
      } else if (field.target) {
        data.attrs.target = field.target;
      }

      if (typeof props.rel !== "undefined") {
        data.attrs.rel = props.rel;
      } else if (data.attrs.target === "_blank") {
        data.attrs.rel = props.blankTargetRelAttribute;
      }

      return h("a", data, children);
    }
  };
});

var RichText = {
  name: "PrismicRichText",
  functional: true,
  props: {
    field: {
      type: Array,
      required: true
    },
    linkResolver: {
      type: Function,
      required: false
    },
    htmlSerializer: {
      type: Function,
      required: false
    },
    wrapper: {
      type: [String, Object, Function],
      required: false,
      "default": "div"
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        parent = _ref.parent;
    var field = props.field,
        linkResolver = props.linkResolver,
        htmlSerializer = props.htmlSerializer,
        wrapper = props.wrapper;

    if (!field) {
      return null;
    }

    var innerHTML = RichText$1.asHtml(field, linkResolver ? linkResolver : parent.$prismic ? parent.$prismic.linkResolver : undefined, htmlSerializer ? htmlSerializer : parent.$prismic ? parent.$prismic.htmlSerializer : undefined);
    return h(wrapper, _objectSpread2(_objectSpread2({}, data), {}, {
      domProps: {
        innerHTML: innerHTML
      }
    }));
  }
};

var Text = {
  name: "PrismicText",
  functional: true,
  props: {
    field: {
      type: Array,
      required: true
    },
    separator: {
      type: String,
      "default": undefined,
      required: false
    },
    wrapper: {
      type: [String, Object, Function],
      required: false,
      "default": "div"
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;
        _ref.children;
        _ref.parent;
    var field = props.field,
        separator = props.separator,
        wrapper = props.wrapper;

    if (!field) {
      return null;
    }

    var innerHTML = RichText$1.asText(field, separator);
    return h(wrapper, _objectSpread2(_objectSpread2({}, data), {}, {
      domProps: {
        innerHTML: innerHTML
      }
    }));
  }
};

// We need to polyfill process if it doesn't exist, such as in the browser.
if (typeof process === "undefined") {
  globalThis.process = {
    env: {}
  };
}
/**
 * `true` if in the production environment, `false` otherwise.
 *
 * This boolean can be used to perform actions only in development environments,
 * such as logging.
 */


var __PRODUCTION__ = process.env.NODE_ENV === "production";

var getSliceComponentProps = function getSliceComponentProps(propsHint) {
  return {
    slice: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    slices: {
      type: Array,
      required: true
    },
    context: {
      type: null,
      required: true
    }
  };
};
var TODOSliceComponent = __PRODUCTION__ ? null : {
  name: "TODOSliceComponent",
  functional: true,
  props: getSliceComponentProps(),
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;
    console.warn("[SliceZone] Could not find a component for Slice type \"".concat(props.slice.slice_type, "\""), props.slice);
    return h("section", _objectSpread2(_objectSpread2({}, data), {}, {
      attrs: _objectSpread2(_objectSpread2({}, data.attrs), {}, {
        "data-slice-zone-todo-component": "",
        "data-slice-type": props.slice.slice_type
      })
    }), ["Could not find a component for Slice type \"".concat(props.slice.slice_type, "\"")]);
  }
}; // Just mimiced to prevent confusion but doesn't provide any value with version 2 of this kit
var SliceZone = {
  name: "SliceZone",
  props: {
    slices: {
      type: Array,
      required: true
    },
    components: {
      type: Object,
      "default": undefined,
      required: false
    },
    resolver: {
      type: Function,
      "default": undefined,
      required: false
    },
    context: {
      type: null,
      "default": undefined,
      required: false
    },
    defaultComponent: {
      type: Object,
      "default": undefined,
      required: false
    },
    wrapper: {
      type: [String, Object, Function],
      "default": "div",
      required: false
    }
  },
  computed: {
    renderedSlices: function renderedSlices() {
      var _this = this;

      if (!this.slices) {
        return null;
      }

      return this.slices.map(function (slice, index) {
        var component = _this.components && slice.slice_type in _this.components ? _this.components[slice.slice_type] : _this.defaultComponent || TODOSliceComponent; // TODO: Remove `resolver` in v3 in favor of `components`.

        if (_this.resolver) {
          var resolvedComponent = _this.resolver({
            slice: slice,
            sliceName: slice.slice_type,
            i: index
          });

          if (resolvedComponent) {
            component = resolvedComponent;
          }
        }

        var p = {
          key: "".concat(slice.slice_type, "-").concat(index),
          props: {
            slice: slice,
            index: index,
            context: _this.context,
            slices: _this.slices
          }
        };
        return {
          component: component,
          p: p
        };
      });
    }
  },
  render: function render(h) {
    // Prevent fatal if user didn't check for field, throws `Invalid prop` warn
    if (!this.slices) {
      return null;
    }

    return h(this.wrapper, this.renderedSlices.map(function (_ref2) {
      var component = _ref2.component,
          p = _ref2.p;
      return h(component, p);
    }));
  }
};

var NuxtLink = Link({
  component: "nuxt-link"
});
var VueRouterLink = Link({
  component: "router-link"
});
var exp = {
  common: {
    Embed: Embed,
    Image: Image,
    RichText: RichText,
    Text: Text,
    SliceZone: SliceZone
  },
  nuxt: {
    Link: NuxtLink
  },
  vueRouter: {
    Link: VueRouterLink
  }
};

function asHtml(richText, linkResolver, htmlSerializer) {
  if (richText) {
    return PrismicDOM.RichText.asHtml(richText, linkResolver, htmlSerializer);
  }
}
function asText(richText, joinString) {
  if (richText) {
    return PrismicDOM.RichText.asText(richText, joinString);
  }

  return "";
}
function asLink(link, linkResolver) {
  if (link) {
    return PrismicDOM.Link.url(link, linkResolver);
  }
}
function asDate(date) {
  if (date) {
    return PrismicDOM.Date(date);
  }
}

var client = prismicJS.client;

function attachMethods(Vue, options) {
  Vue.prototype.$prismic.asHtml = function (richText, linkResolver, htmlSerializer) {
    return asHtml(richText, linkResolver || options.linkResolver, htmlSerializer || options.htmlSerializer);
  };

  Vue.prototype.$prismic.asHTML = Vue.prototype.$prismic.asHtml;
  Vue.prototype.$prismic.asText = asText;
  Vue.prototype.$prismic.richTextAsPlain = asText;
  Vue.prototype.$prismic.asDate = asDate;

  Vue.prototype.$prismic.asLink = function (link, linkResolver) {
    return asLink(link, linkResolver || options.linkResolver);
  };
}

var PrismicVue = {
  install: function install(Vue, options) {
    var _options$linkType = options.linkType,
        linkType = _options$linkType === void 0 ? "vueRouter" : _options$linkType;
    Vue.prototype.$prismic = prismicJS;
    Vue.prototype.$prismic.predicate = prismicJS.Predicates;
    Vue.prototype.$prismic.cookie = {
      preview: prismicJS.previewCookie
    };
    Vue.prototype.$prismic.endpoint = options.endpoint;
    Vue.prototype.$prismic.linkResolver = options.linkResolver;
    Vue.prototype.$prismic.htmlSerializer = options.htmlSerializer;
    Vue.prototype.$prismic.client = client(options.endpoint, options.apiOptions);
    attachMethods(Vue, options);

    var components = _objectSpread2(_objectSpread2({}, exp.common), exp[linkType]);
    /**
     * Global registration of common components + stack specific components.
     * Currently, only Nuxt links differ though. Use `linkType: 'nuxt'` in that case.
     */


    Object.entries(components).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2);
          _ref2[0];
          var c = _ref2[1];

      Vue.component(c.name, c);
    });
  }
};

export { PrismicVue as default };
